/** Lead da LP/Gate: tem preferences.gate e ainda não concluiu o cadastro VIP. */
export function isGateLeadOnly(user) {
  const prefs = user?.preferences;
  if (!prefs || typeof prefs !== "object") return false;
  if (prefs.app_registered_at) return false;
  return Boolean(prefs.gate && typeof prefs.gate === "object");
}

export function allowLegacyAppLogin(user) {
  const gate = user?.preferences?.gate;
  return Boolean(gate && typeof gate === "object" && gate.legacy_app_ok);
}

/** Lead nova: não entra pelo login. As que já acessaram o app têm legacy_app_ok. */
export function mustRegisterAgain(user) {
  return isGateLeadOnly(user) && !allowLegacyAppLogin(user);
}
